import React from 'react';
import ButtonsSearch from '../../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../../../components/NovoSistema/InputText';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function MotivoDeAjusteSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Código" id="CodeProduto" widthPercentage="40%" />
          <InputText title="Descrição" id="DescricaoProduto" widthPercentage="40%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
    </div>
  );
}
